module.exports = __webpack_public_path__ + "img/41_50.47dbae0f.png";